import React from "react";
import { useDebouncedCallback } from "use-debounce";

import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import Menu from "@mui/material/Menu";
import { filterColumns } from "../column-manager";
import useModalState from "../../../../hooks/use-modal-state";
import ExportReports from "./features/export-reports";
import toast from "react-hot-toast";
import ToolbarWrapper from "../../../components/toolbar-wrapper";

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// month filters
// weired naming
const monthFiltersArray = [
  "One",
  "Second",
  "Third",
  "Fourth",
  "fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Delivered",
];

const monthFilters = monthFiltersArray.map((m) => {
  return {
    _id: m,
    name: m,
  };
});

// trimester
const trimesterArray = ["First", "Second", "Third", "Delivered"];

const trimesterFilter = trimesterArray.map((m) => {
  return {
    _id: m,
    name: m,
  };
});

export const Connected = (props) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    map,
  } = useSelector((state) => state.user || {});
  const history = useHistory();
  const [data, setData] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [selected, setSelected] = React.useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [creating, setCreating] = useState(false);
  const [createCompleted, setCreateCompleted] = useState(false);
  const [remainingFollowups, setRemainingFollowups] = useState(null);
  const [totalMother, setTotalMother] = useState(null);
  const [cycleCompleted, setCycleCompleted] = useState(0);

  const {
    isOpen: isEcdExportModalOpen,
    openModal: openEcdExportModal,
    closeModal: closeEcdExportModal,
    data: ecdExportData,
    setData: setEcdExportData,
  } = useModalState();

  const [exportLoading, setExportLoading] = useState(false);
  const [exportDateRange, setExportDateRange] = useState({
    from: null,
    to: null,
  });

  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState({
    from: null,
    to: null,
  });

  const [listLoading, setListLoading] = useState(false);

  const debounced = useDebouncedCallback((value) => {
    setFilter({ ...value });
  }, 1000);

  const toolbarButtons = [
    // {
    //     name: 'Manual Assign',
    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
    //     onClick: () => {
    //         // exportReport(new Date())
    //         // history.push('/lead/call-data/reports/QualityAssurance')
    //     },
    //     // isDisabled: false
    // },
    // {
    //     name: 'Add to Quality Assurance',
    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
    //     onClick: () => {
    //         // exportReport(new Date())
    //     },
    //     // isDisabled: false
    // },
    // {
    //     name: 'Download Report',
    //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
    //     onClick: () => {
    //         // exportReport(new Date())
    //     },
    //     // isDisabled: false
    // },

    /**
     * OLD LOGIC when data type was static,
     * to create follow up calls
     */
    // {
    //   name: createCompleted ? 'Follow up completed' : creating ? 'Creating followup casses.....' : `Create Followup Calls`,
    //   // type: 'chip',
    //   icon: () => <IosShareIcon sx={{ fontSize: "1.2em" }} />,
    //   onClick: () => {
    //     if (!creating) {
    //       createCases()
    //     }
    //   },
    // },
    {
      name: `Export ${selectedRows.length ? `(${selectedRows.length})` : (count || 0) > 5000 ? `(${count}) is not possible (MAX export limit is 50000)` : count}`,
      // type: 'chip',
      icon: () => <IosShareIcon sx={{ fontSize: "1.2em" }} />,
      sxx: count <= 50000 ? {} : { color: "rgb(211, 47, 47)" },
      onClick: () => {
        if (count < 50000) {
          if (filter.from && filter.to) {
            if (dayjs(filter.from).isAfter(dayjs(filter.to))) {
              toast.error("From date cannot be after to date", {
                duration: 2000,
                position: "top-center",
              });
              return;
            }

            openEcdExportModal();
            // exportReport(new Date());
          } else {
            toast.error("Please select a date range", {
              duration: 2000,
              position: "top-center",
            });
          }
        }
      },
    },
    {
      name: "Today",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        setFilter({ ...filter, from: dayjs(), to: dayjs() });
      },
    },
    {
      name: "This week",
      // type: 'chip',
      // icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
      onClick: () => {
        const start = dayjs().weekday(-7);
        const end = start.add(6, "day");
        // console.log(start.format('DD-MM-YYYY'), end.format('DD-MM-YYYY'))
        setFilter({ ...filter, from: start, to: end });
      },
    },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterString = (filter) => {
    let queryString = "";
    if (filter.motherID) {
      queryString += `&motherID=${filter.motherID}`;
    }

    if (filter.bName) {
      queryString += `&bName=${filter.bName}`;
    }

    if (filter.age) {
      queryString += `&age=${filter.age}`;
    }

    if (filter.week) {
      queryString += `&week=${filter.week}`;
    }

    if (filter.pregnancyMonth) {
      // queryString += `&pregnancyMonth=${filter.pregnancyMonth}`;
      queryString += `&pregnancyMonth=${encodeURIComponent(JSON.stringify(filter.pregnancyMonth))}`;
    }

    if (filter.trimester) {
      // queryString += `&trimester=${filter.trimester}`;
      queryString += `&trimester=${encodeURIComponent(JSON.stringify(filter.trimester))}`;
    }

    if (filter.pregnancyStatus) {
      // queryString += `&pregnancyStatus=${filter.pregnancyStatus}`;
      queryString += `&pregnancyStatus=${encodeURIComponent(JSON.stringify(filter.pregnancyStatus))}`;
    }

    if (filter.district) {
      queryString += `&district=${encodeURIComponent(JSON.stringify(filter.district))}`;
    }

    if (filter.agent) {
      queryString += `&agent=${encodeURIComponent(JSON.stringify(filter.agent))}`;
    }

    if (filter.cluster) {
      queryString += `&cluster=${filter.cluster}`;
    }

    if (filter.dataType) {
      // queryString += `&dataType=${filter.dataType}`;
      queryString += `&dataType=${encodeURIComponent(JSON.stringify(filter.dataType))}`;
    }

    if (filter.data_type) {
      // queryString += `&data_type=${encodeURIComponent(JSON.stringify(filter.data_type))}`;
      queryString += `&data_type=${encodeURIComponent(filter.data_type)}`;
    }

    if (filter.childDeliveryPlace) {
      // queryString += `&childDeliveryPlace=${filter.childDeliveryPlace}`;
      queryString += `&childDeliveryPlace=${encodeURIComponent(JSON.stringify(filter.childDeliveryPlace))}`;
    }

    if (filter.homeDeliverReason) {
      // queryString += `&homeDeliverReason=${filter.homeDeliverReason}`;
      queryString += `&homeDeliverReason=${encodeURIComponent(JSON.stringify(filter.homeDeliverReason))}`;
    }

    if (filter.childImmunization) {
      // queryString += `&childImmunization=${filter.childImmunization}`;
      queryString += `&childImmunization=${encodeURIComponent(JSON.stringify(filter.childImmunization))}`;
    }

    if (filter.nonImmunizedReason) {
      // queryString += `&nonImmunizedReason=${filter.nonImmunizedReason}`;
      queryString += `&nonImmunizedReason=${encodeURIComponent(JSON.stringify(filter.nonImmunizedReason))}`;
    }

    if (filter.highRisk) {
      // queryString += `&highRisk=${filter.highRisk}`;
      queryString += `&highRisk=${encodeURIComponent(JSON.stringify(filter.highRisk))}`;
    }

    if (filter.lessThen1Year) {
      // queryString += `&lessThen1Year=${filter.lessThen1Year}`;
      queryString += `&lessThen1Year=${encodeURIComponent(JSON.stringify(filter.lessThen1Year))}`;
    }

    if (filter.between1And2) {
      // queryString += `&between1And2=${filter.between1And2}`;
      queryString += `&between1And2=${encodeURIComponent(JSON.stringify(filter.between1And2))}`;
    }

    if (filter.advice) {
      queryString += `&advice=${filter.advice}`;
    }
    if (filter.callStatus) {
      // queryString += `&callStatus=${filter.callStatus}`;
      queryString += `&callStatus=${encodeURIComponent(JSON.stringify(filter.callStatus))}`;
    }

    return queryString;
  };

  const getReports = () => {
    const queryString = filterString(filter);
    setListLoading(true);
    axios
      .get(
        API_HOST_CRM +
          `/ecd-reports?limit=${rowsPerPage}&page=${page}&${filter.from ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}` : ""}` +
          `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
          `${queryString}`,
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.ecd);
          setCount(resp.data.count);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setListLoading(false);
      });
  };

  useEffect(() => {
    getReports();
  }, [page, rowsPerPage]);

  useEffect(() => {
    getReports();
  }, []);
  useEffect(() => {
    if (filter.to || filter.from) {
      setExportDateRange({
        from: filter?.from ? dayjs(filter.from) : null,
        to: filter?.to ? dayjs(filter.to) : null,
      });
    }

    const timeoutId = setTimeout(() => {
      getReports();
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [filter]);

  useEffect(() => {
    // console.log('------------->', selectedRows.map(e => e._id))
  }, [selectedRows]);

  useEffect(() => {
    getRemainingFollowups();
  }, []);

  const getRemainingFollowups = () => {
    axios
      .get(API_HOST_CRM + `/remaining-ecd-followup`)
      .then((resp) => {
        if (resp.data.success) {
          setCycleCompleted(resp.data.completed);
          setRemainingFollowups(resp.data.remainingFollowups);
          setTotalMother(resp.data.distinctMother);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const exportReport = () => {
    const queryString = filterString(filter);
    setExportLoading(true);
    if (true) {
      axios
        .get(
          API_HOST_CRM +
            `/ecd/export-all?&ids=${encodeURIComponent(JSON.stringify((selectedRows || []).map((e) => e._id)))}` +
            `${filter.from ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}` : ""}` +
            `${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
            `${queryString}`,
          {
            responseType: "arraybuffer",
          },
        )
        .then((resp) => {
          if (resp) {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              // `ECD_Report_${dayjs(filter.from).format("DD-MM-YYYY")}-${dayjs(
              //   filter.to
              // ).format("DD-MM-YYYY")}.xlsx`
              `ECD_Report_${dayjs().format("DD-MM-YYYY HH:mm:ss")}.xlsx`,
            );
            document.body.appendChild(link);
            link.click();
            console.log(resp);
            link.remove();
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setExportLoading(false);
        });
    }
  };

  const createCases = () => {
    setCreating(true);
    axios
      .get(API_HOST_CRM + "/create-auto")
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setCreating(false);
          setCreateCompleted(true);
          getRemainingFollowups();
          setTimeout(() => {
            setCreateCompleted(false);
          }, 2000);
        }
        setCreating(false);
      })
      .catch((e) => {
        console.log(e);
        setCreating(false);
      });
  };

  return (
    <>
      <Box sx={{ mt: 1, display: "flex" }}>
        <h5>Remaining followups: {remainingFollowups || 0}</h5> &nbsp;
        &nbsp;&nbsp; <h5>Cycle Completed: {cycleCompleted || 0}</h5>
        &nbsp; &nbsp;&nbsp; <h5>Total Mothers: {totalMother || 0}</h5>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <ToolbarWrapper>
          <ToolBar
            name={""}
            buttons={toolbarButtons}
            open={open}
            flex={"column"}
            height={"100%"}
            handleClose={handleClose}
            anchorEl={anchorEl}
            filters={[
              {
                field: {
                  name: "from",
                  type: "date",
                  label: "From",
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },
              {
                field: {
                  name: "to",
                  type: "date",
                  label: "To",
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },

              // Data type filter
              {
                minWidth: 150,
                field: {
                  name: "data_type",
                  type: "select",
                  label: "Data Type",
                  option: {
                    key: "DataTypes",
                    value: "_id",
                    label: "name",
                  },
                  noMb: true,
                },
                data: {
                  DataTypes: [
                    { _id: "Any", name: "Any" },
                    // Data type renaming
                    {
                      _id: "new_data_current_month",
                      name: "New Data Current Month",
                    },
                    {
                      _id: "new_data_current_month_delivered",
                      name: "New Data Current Month Delivered",
                    },
                    {
                      _id: "previous_months_unreached_calls",
                      name: "Previous Month Unreached Calls",
                    },
                    {
                      _id: "previous_months_pending_calls",
                      name: "Previous Month Pending Calls",
                    },
                    {
                      _id: "followup_calls",
                      name: "Followup Calls",
                    },
                    // {
                    //   _id: "new_data_current_month",
                    //   name: "New Data Current Month",
                    // },
                    // {
                    //   _id: "new_data_current_month_delivered",
                    //   name: "New Data Current Month Delivered",
                    // },
                    // {
                    //   _id: "previous_month_unreached_calls",
                    //   name: "Previous Month Unreached Calls",
                    // },
                    // {
                    //   _id: "previous_month_pending_calls",
                    //   name: "Previous Month Pending Calls",
                    // },
                    // {
                    //   _id: "followup_calls_40_days",
                    //   name: "Follow-up Calls 40 Days",
                    // },
                    // {
                    //   _id: "followup_calls_90_days",
                    //   name: "Follow-up Calls 90 Days",
                    // }
                    // End Data type renaming
                    // Not removing the comments because i am petty. This is suppose to be in "production". WHAT A MESS, BOTH THIS PROJECT AND THE PEOPLE WHO WERE MANAGING IT.
                    // { _id: "followup_calls", name: "Follow-up calls" },
                    // // { _id: "followup_calls_delivered", name: "Follow-up calls(Delivered)" },
                    // { _id: "new_data", name: "New Data" },
                    // {
                    //   _id: "previously_unreached",
                    //   name: "Previously Unreached from previous months",
                    // },
                    // {
                    //   _id: "previously_unattempted",
                    //   name: "Previously Pending from previous months",
                    // },
                    // { _id: "delivered", name: "Delivered(Current Month)" },
                    // {
                    //   _id: "previously_delivered",
                    //   name: "Delivered(Not Current Month)",
                    // },
                    // {
                    //   _id: "previously_unreached_delivered",
                    //   name: "Previously Unreached from previous months(Delivered)",
                    // },
                    // {
                    //   _id: "previously_unattempted_delivered",
                    //   name: "Previously Pending from previous months(Delivered)",
                    // },
                  ],
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  console.log("-------------------------------->33");
                  setFilter({ ...filter });
                },
                state: filter,
              },
            ]}
            onClearFilter={() => {
              setFilter({
                lastAttemptDateFrom: null,
                lastAttemptDateTo: null,
                from: null,
                to: null,
                cfrom: null,
                cto: null,
                firstReceived: null,
                motherName: "",
                motherID: "",
                contact: "",
                status: null,
                motherStatus: null,
                telecaller: null,
                district: null,
                upload_date_from: null,
                upload_date_to: null,
              });
            }}
          />
        </ToolbarWrapper>
        <Box sx={{ mt: 2 }}>
          <Grid
            isLoading={listLoading}
            data={data}
            columns={[
              ...filterColumns(
                [
                  {
                    id: "motherID",
                    showFilter: "true",
                    minWidth: 150,
                  },
                  {
                    id: "bName",
                    label: "Name",
                    minWidth: 200,
                    showFilter: true,
                  },
                  { id: "age", label: "Age", minWidth: 100, showFilter: true },
                  {
                    id: "week",
                    label: "Week",
                    minWidth: 100,
                    showFilter: true,
                  },
                  {
                    id: "pregnancyMonth",
                    label: "Month",
                    minWidth: 100,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "trimester",
                    label: "Trimester",
                    minWidth: 100,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "pregnancyStatus",
                    label: "Pregnancy Status",
                    minWidth: 200,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "district",
                    label: "District",
                    minWidth: 150,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "agent",
                    label: "Caller",
                    minWidth: 100,
                    showFilter: true,
                    format: (data, row) => {
                      if (map.users) {
                        return map.users?.[data]?.name || data;
                      }
                      return data;
                    },
                  },
                  {
                    id: "cluster",
                    label: "Cluster",
                    minWidth: 150,
                    showFilter: true,
                  },
                  // This is a dynamic value so added the filter on the toolbar
                  // { id: "dataType", label: "Data Type", minWidth: 150, showFilter: true, type: "select" },
                  {
                    id: "callStatus",
                    label: "Status",
                    minWidth: 150,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "trimester",
                    label: "Trimester of Pregnancy",
                    minWidth: 150,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "childDeliveryPlace",
                    label: "Place of Child being Delivered",
                    minWidth: 200,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "homeDeliverReason",
                    label: "If Delivered at home, what was the reason?",
                    minWidth: 200,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "childImmunization",
                    label: "Has the child been immunized?",
                    minWidth: 200,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "nonImmunizedReason",
                    label:
                      "If the child has not been immunized, what was the reason?",
                    minWidth: 200,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "highRisk",
                    label: "Is the pregnancy a high risk?",
                    minWidth: 150,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "lessThen1Year",
                    label: "Children under 1 year",
                    minWidth: 150,
                    type: "select",
                    showFilter: true,
                  },
                  {
                    id: "between1And2",
                    label: "Child from 1 - 2 Year old?",
                    minWidth: 150,
                    showFilter: true,
                    type: "select",
                  },
                  {
                    id: "advice",
                    label: "Advice",
                    minWidth: 150,
                    format: (data, row) => {
                      return (data || "").substring(0, 30);
                    },
                    showFilter: true,
                  },
                ],
                filter,
                setFilter,
                { Districts, users, map },
              ),

              {
                id: "callDate",
                label: "Call Date",
                minWidth: 70,
                format: (data, row) => {
                  // return data ? dayjs(data.split('T')[0]).format("DD-MM-YYYY") : "";
                  return data ? dayjs(data).format("DD-MM-YYYY") : "";
                },
              },
              // { id: 'callerType', label: 'Call Type', minWidth: 50 },

              // { id: 'sankalpId', label: 'Sankalp Data', minWidth: 50, format: (data, row) => {
              //     if(data) {
              //         return (<Button onClick={() => {
              //             setOpen(true)
              //             setSelectedSankalpData(data)
              //         }}>View</Button>)
              //     } else {
              //         return ''
              //     }
              // } },
            ]}
            pagination={{
              rowsPerPageOptions: [10, 25, 50],
              page,
              rowsPerPage,
              onPageChange: (event, newPage) => {
                setPage(newPage);
              },
              onRowsPerPageChange: (event) => {
                setRowsPerPage(+event.target.value);
                setPage(0);
              },
              count,
            }}
            onSelectChange={(selected) => {
              setSelectedRows([...selected]);
            }}
          ></Grid>
        </Box>
      </Box>
      <ExportReports
        exportReportsOpen={isEcdExportModalOpen}
        handleExportReportsClose={closeEcdExportModal}
        exportLoading={exportLoading}
        onExport={exportReport}
        filter={filter}
        setFilter={setFilter}
        showFilters={true}
        exportDateRange={exportDateRange}
        setExportDateRange={setExportDateRange}
        selectedRows={selectedRows}
      />
    </>
  );
};
